// ProductCard.jsx
import React from "react";
import { useFilters } from "./FilterContext";

function ProductCard({ product }) {
  const { setMobilePopUpData, setopenPopup } = useFilters();

  return (
    <div
      className="card"
      data-test={`card-${product.product_id}`}
      data-entity-id={product.product_id}
    >
      <figure className="card-figure">
        {/* <a href={product.product_info.custom_url.url} className="card-figure__link" aria-label={product.name}> */}
        <a
          href={product.custom_url}
          className="card-figure__link"
          aria-label={product.name}
          title={product.name}
        >
          <div className="card-img-container">
            <img
              src={product.photo_small}
              alt={product.name}
              title={product.name}
              className="card-image"
            />
          </div>
        </a>
        <span className="popup" onClick={e => {
          const popupContent = product.image_description?.trim()
            ? product.image_description
            : product.name;

          setMobilePopUpData(popupContent);
          setopenPopup(true);
          setopenPopup(true)
          document.body.style.overflow = 'hidden';
        }} style={{ cursor: "pointer" }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><g id="Group_2" data-name="Group 2" transform="translate(-909 -232)"><circle id="Ellipse_2" data-name="Ellipse 2" cx="20" cy="20" r="20" transform="translate(909 232)" fill="#888"></circle><path id="info_5593544" d="M27.76,31.874l-.437,1.459a.448.448,0,0,1-.27.289,13.422,13.422,0,0,1-4.789,1.234,5.743,5.743,0,0,1-3.356-1.17c-2.038-1.363-.752-5.721.379-9.566.174-.591.341-1.157.482-1.678.141-.5.238-1.17-.109-1.491-.611-.559-2.314-.1-2.861.1a.476.476,0,0,1-.463-.077.468.468,0,0,1-.148-.444l.3-1.427a.455.455,0,0,1,.251-.321A16.5,16.5,0,0,1,21.01,17.6a4.622,4.622,0,0,1,4.2,1.2c.829.984,1.035,2.462.617,4.4-.058.264-.193.694-.386,1.286-.579,1.781-1.652,5.091-1.427,6.525a.712.712,0,0,0,.354.553c.714.411,2.282-.051,2.784-.244a.449.449,0,0,1,.476.09.457.457,0,0,1,.129.469ZM24.5,15.79a3.324,3.324,0,1,1,3.324-3.324A3.324,3.324,0,0,1,24.5,15.79Z" transform="translate(906.821 229.857)" fill="#fff"></path></g></svg>
          {/* <img src="https://store-hznj0tgte3.mybigcommerce.com/content/info.png" alt="info-icon" /> */}
        </span>
        {/* <figcaption className="card-figcaption">
          <div className="card-figcaption-body">
            <a href={product.addToCartUrl} className="button button--small card-figcaption-button">
              Add to Cart
            </a>
          </div>
        </figcaption> */}
      </figure>
      <div className="card-body">
        <h3 className="card-title">
          {/* <a href={product.product_info.custom_url.url}>{product.name}</a> */}
          <a href={product.custom_url} title={product.name}>
            {product.name}
          </a>
        </h3>
        <div className="card-text" data-test-info-type="price">
          <div className="price-section price-section--withoutTax non-sale-price--withoutTax">
            <span className="price-original-label">Was: </span>
            <span
              className={`price${product.sale_price !== undefined && product.sale_price > 0
                ? " price--non-sale"
                : ""
                }`}
            >
              ${product.product_price}
            </span>
          </div>
          {product.sale_price !== undefined && product.sale_price > 0 && (
            <div className="price-section price-section--withoutTax price--withoutTax sale-price">
              <span className="price-now-label">Now: </span>
              <span className="price">${product.sale_price}</span>
            </div>
          )}
        </div>
        {/* <span className="popup" onClick={e => {
                const popupContent = product.image_description?.trim()
                  ? product.image_description
                  : product.name;

                setMobilePopUpData(popupContent);
                setopenPopup(true);
                setopenPopup(true)
                document.body.style.overflow = 'hidden';
            }} style={{ cursor: "pointer" }}> 
            <img src="https://store-hznj0tgte3.mybigcommerce.com/content/info.png" alt="info-icon" />
          </span> */}
      </div>
    </div>
  );
}

export default ProductCard;
